import { PasswordDesignTokens } from '@primeuix/themes/types/password';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/password/index.ts
const pw = componentCommon.password;
const pwCs = componentColorScheme.password;

export const PasswordTelekomDT: PasswordDesignTokens = {
  meter: {
    background: t(pw.meter.background),
    borderRadius: t(pw.meter.border.radius),
    height: t(pw.meter.height),
  },
  icon: {
    color: t(pw.icon.color),
  },
  overlay: {
    background: t(pw.overlay.background),
    borderColor: t(pw.overlay.border.color),
    borderRadius: t(pw.overlay.border.radius),
    color: t(pw.overlay.color),
    padding: t(pw.overlay.padding),
  },
  content: {
    gap: t(pw.content.gap),
  },
  strength: {
    weakBackground: t(pwCs.strength.weak.background),
    mediumBackground: t(pwCs.strength.medium.background),
    strongBackground: t(pwCs.strength.strong.background),
  },
};
